import PropTypes from 'prop-types'
import React from 'react'

import {
    Checkbox,
    Role,
    TableBodyCell,
    Member,
} from 'react-wot-bootstrap'

import { NotLoggedInEverTooltip } from '../ClanManagement/tooltips'

import TableBodyCellWithCM from '../../containers/TableBodyCellWithCM'
import FormattedTimeSince from '../FormattedTimeSince/FormattedTimeSince'

import { PLAYER_STATUS_ONLINE } from './translations'

import { roleNames } from 'utils/clan_management/roles'

class BaseMembersTableItem extends React.PureComponent {
    static propTypes = {
        memberId: PropTypes.number.isRequired,
        memberDaysInClan: PropTypes.number.isRequired, // eslint-disable-line react/no-unused-prop-types
        memberRole: PropTypes.oneOf(roleNames).isRequired,
        memberName: PropTypes.string.isRequired,

        memberStatus: PropTypes.string,
        memberLogoutAt: PropTypes.number,
        isOwn: PropTypes.bool,
        isFriend: PropTypes.bool,
        isActive: PropTypes.bool,
        isChecked: PropTypes.bool,
        displayCheckbox: PropTypes.bool,
        isCMDisplayed: PropTypes.bool,

        onTickMember: PropTypes.func,
        onContextMenuItemSelected: PropTypes.func,
        onContextMenuStateChanged: PropTypes.func,
    }

    static defaultProps = {
        isActive: false,
        isFriend: false,
        isChecked: false,
        displayCheckbox: false,
        memberStatus: 'offline',
        onTickMember: () => {},
        onContextMenuStateChanged: () => {},
    }

    constructor(props) {
        super(props)

        this.onContextMenu = this.onContextMenu.bind(this)
        this.onContextMenuItemSelected = this.onContextMenuItemSelected.bind(this)
        this.onCheckboxChange = this.onCheckboxChange.bind(this)
        this.onRowClick = this.onRowClick.bind(this)
    }

    isRowActive() {
        return this.props.isActive || this.props.isCMDisplayed
    }

    needPlayHoverSound() {
        return this.props.displayCheckbox && !this.isRowActive()
    }

    onContextMenu() {
        this.props.onContextMenuStateChanged(this.props.memberId, true)
    }

    onContextMenuItemSelected(data) {
        this.props.onContextMenuStateChanged(this.props.memberId, false)
        this.props.onContextMenuItemSelected(data)
    }

    onCheckboxChange() {
        this.props.onTickMember(this.props.memberId)
    }

    onRowClick() {
        this.props.onTickMember(this.props.memberId)
    }

    renderTableCellCheckbox() {
        return this.props.displayCheckbox ? (
            <TableBodyCell type="check">
                <Checkbox
                    isSilent
                    isChecked={this.props.isChecked}
                    onChange={this.onCheckboxChange}
                />
            </TableBodyCell>
        ) : null
    }

    renderTableCellRole() {
        const role = this.props.memberRole
        return (
            <TableBodyCell
                tooltipId='member-role-tooltip'
                tooltipTip={role}
                type='role'
            >
                <Role role={role} />
            </TableBodyCell>
        )
    }

    renderTableCellMember(children) {
        const id = this.props.memberId
        return (
            <TableBodyCellWithCM
                id={id}
                type="basis"
                tooltipId={this.props.isCMDisplayed ? null : 'member-name-tooltip'}
                tooltipTip={this.props.isCMDisplayed ? null : `${id}`}
                onContextMenu={this.onContextMenu}
                onContextMenuItemSelected={this.onContextMenuItemSelected}
            >
                <Member
                    name={this.props.memberName}
                    status={this.props.memberStatus}
                    isOwn={this.props.isOwn}
                    isFriend={this.props.isFriend}
                />
                {children}
            </TableBodyCellWithCM>
        )
    }

    renderTableCellMemberStatus() {
        const status = this.props.memberStatus
        const isOnline = status === 'online' || status === 'busy'

        let message = null
        let tooltipId = null
        if (isOnline) {
            message = PLAYER_STATUS_ONLINE
        } else {
            message = <FormattedTimeSince timestamp={this.props.memberLogoutAt} />
            tooltipId = this.props.memberLogoutAt ? null : NotLoggedInEverTooltip.id
        }

        const valueType = isOnline ? 'positive' : undefined
        return (
            <TableBodyCell
                tooltipId={tooltipId}
                type='center'
                valueType={valueType}
            >
                {message}
            </TableBodyCell>
        )
    }
}

export default BaseMembersTableItem



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/MembersTable/BaseMembersTableItem.js